import { TApplicationState } from '../types/redux';

export const selectIsNewbuilding = (state: TApplicationState) => {
  return state.newbuilding.isNewbuilding;
};

export const selectNewbuildingName = (state: TApplicationState) => {
  return state.newbuilding.newbuildingName;
};

export const selectNewbuildingId = (state: TApplicationState) => {
  return state.newbuilding.newbuildingId;
};
